<div class="main">
    <span class="left">{{textFalse}}</span>
    <p-inputSwitch [(ngModel)]="value" (onChange)="switch()"></p-inputSwitch>
    <span class="right">{{textTrue}}</span>
</div>
